import React from 'react';
import BEMHelper from '@ynap/bem-helper';
import { SimpleErrorPage } from '..';
import PropTypes from 'prop-types';

const bem = new BEMHelper('ErrorBoundary');

export default class ErrorBoundary extends React.Component {
    static propTypes = {
        children: PropTypes.object,
        error: PropTypes.shape({
            status: PropTypes.string,
            message: PropTypes.string,
        }),
    };

    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    componentDidCatch(error) {
        this.setState({ hasError: true, error });
    }

    render() {
        if (this.state.hasError) {
            const { className } = this.props;
            return (
                <div className={bem(null, null, className)}>
                    <SimpleErrorPage {...this.props} error={this.state.error} />
                </div>
            );
        }
        return this.props.children;
    }
}
